<template>
  <b-modal
    v-if="dataUtm"
    id="modal-utm"
    v-model="showModal"
    centered
    hide-footer
  >
    <div class="content">
      <div class="content-body h6">
        <img
          v-if="dataUtm.ruta_logo"
          :src="dataUtm.ruta_logo"
          alt="Logo Quac"
        />
        <div class="w-100">
          <h6 class="title" v-html="dataUtm.titulo" />
          <img
            v-if="dataUtm.ruta_imagen"
            :src="dataUtm.ruta_imagen"
            alt="Imagen de campaña Quac"
            class="img-description"
          />
          <div class="description" v-html="dataUtm.descripcion" />
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      showModal: false,
      dataUtm: null,
    }
  },
  async mounted() {
    const utm_campaign = new URLSearchParams(window.location.search).get(
      'utm_campaign',
    )
    if (utm_campaign) {
      const utm_campaign_local = localStorage.getItem('utm_campaign')
      const utm_user_id_local = localStorage.getItem('utm_user_id')

      const utm_user_id = utm_user_id_local ?? `user-id-${crypto.randomUUID()}`

      let data = new FormData()
      data.append('utm_campaign', utm_campaign)
      data.append('utm_user_id', utm_user_id)
      await this.axios({
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/layout/get_campania_push',
        data: data,
      }).then(response => {
        if (!response.data.status) {
          this.showModal = false
          return
        }
        this.dataUtm = response.data.campaign

        if (utm_campaign_local != utm_campaign) {
          localStorage.setItem('utm_campaign', utm_campaign)
          localStorage.setItem('utm_user_id', utm_user_id)
          localStorage.setItem('utm_datestamp', new Date().toDateString())
        }
        this.showModal = true
      })
    }
  },
}
</script>
<style>
#modal-utm .modal-header {
  position: absolute;
  border: none;
  right: 0;
}
#modal-utm .modal-header .close {
  font-size: 30px;
  text-transform: uppercase;
  line-height: 0.5;
  border: none;
  background: none;
  cursor: pointer;
  z-index: 10;
}
#modal-utm .modal-content {
  border: 0;
  border-radius: 10px;
}

#modal-utm .modal-dialog {
  align-items: flex-start;
}

#modal-utm .content {
  padding: 0.2rem 0;
  text-align: start;
}

#modal-utm .content-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  align-items: flex-start;
}

#modal-utm .content-body img {
  max-width: 60px;
  border-radius: 6px;
}

#modal-utm .content-body .img-description {
  max-width: 100% !important;
  margin-bottom: 0.8rem;
  border-radius: 0px;
}

#modal-utm .content-body .title {
  font-size: 1.15rem;
  font-weight: 900;
  margin-bottom: 1rem;
  margin-top: 0.25rem;
  margin-right: 0;
}

@media (min-width: 768px) {
  #modal-utm .content-body {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  #modal-utm .content-body .title {
    margin-right: 2rem;
  }
  #modal-utm .content-body img {
    max-width: 90px;
  }
}
</style>
